module.exports = __webpack_public_path__ + "media/images/pc/top/area_brand_aqua-6e0e0092394f770674f0d7723b4bc2bd.webp";